export default __webpack_public_path__ + "static/media/kriss-header.9011e786.png";